const actionType = {
  SET_MODAL: 'SET_MODAL',
  CLEAR_MODAL: 'CLEAR_MODAL'
};

export default actionType;